// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2RzWL","footer":"ModalError_footer__14a4L"};